module.exports = __webpack_public_path__ + "img/IMG_0652.70161851.png";